import { render } from "./SittingMenu.vue?vue&type=template&id=27d061b2&scoped=true"
import script from "./SittingMenu.vue?vue&type=script&lang=js"
export * from "./SittingMenu.vue?vue&type=script&lang=js"

import "./SittingMenu.vue?vue&type=style&index=0&id=27d061b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d061b2"]])

export default __exports__